import { Icon } from 'components/Icon';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './StoreQuantityStepper.scss';
/**
 * @component StoreQuantityStepper
 * @since 1.0.0
 */
export function StoreQuantityStepper(props) {
    const { value, max, onChange, onRemove } = props;
    const removes = value <= 1 && onRemove != null;
    const className = classNames('store-quantity-stepper', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("button", { type: "button", className: "store-quantity-stepper__btn", disabled: value <= 1 && !removes, onClick: () => (removes ? onRemove === null || onRemove === void 0 ? void 0 : onRemove() : onChange(value - 1)), "aria-label": removes ? t('Remove') : t('Decrease quantity') },
            React.createElement(Icon, { value: removes ? 'trash-can' : 'minus' })),
        React.createElement("span", { className: "store-quantity-stepper__value" }, value),
        React.createElement("button", { type: "button", className: "store-quantity-stepper__btn", disabled: max != null && value >= max, onClick: () => onChange(value + 1), "aria-label": t('Increase quantity') },
            React.createElement(Icon, { value: "plus" }))));
}
